import { Box, styled, Typography } from '@mui/material';

export const AvailableWrapperStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isAvailable',
})<{ isAvailable?: boolean }>(({ theme, isAvailable }) => ({
  width: '100%',
  borderRadius: theme.spacing(4),
  backgroundColor: isAvailable ? theme.palette.green[100] : theme.palette.error[100],
  textAlign: 'center',
  padding: theme.spacing(0.5, 1),
  height: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const AvailableStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isAvailable',
})<{ isAvailable?: boolean }>(({ theme, isAvailable }) => ({
  color: isAvailable ? theme.palette.green[900] : theme.palette.error[900],
  fontWeight: 700,
}));

export const IconWrapperStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary[100],
  borderRadius: '50%',
  width: theme.spacing(4),
  minWidth: theme.spacing(4),
  height: theme.spacing(4),
  minHeight: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const DateLabelStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary[500],
}));

export const DateStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900],
}));

export const ContactLabelStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral[600],
  textWrap: 'wrap',
}));

export const ContactStyled = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.grey[900],
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
}));
